import { createSelector } from 'reselect'
import featureFlagsTypes from 'helpers/enums/featureFlagsTypes'
import featureFlagsSelectorCreator from 'redux/selectors/feature_flags/feature_flags_selector'

const featureFlagsSelector = featureFlagsSelectorCreator([
	featureFlagsTypes.CSE_IMAGE_SEARCH,
])

const creationToolContainerSelector = createSelector(
	[featureFlagsSelector],
	featureFlags => (
		{
			canUseCSESearch: featureFlags[featureFlagsTypes.CSE_IMAGE_SEARCH],
		}
	)
)

export default creationToolContainerSelector
